import styled from "styled-components"

export const Container = styled.div`
  margin: auto;
  width: 100%;
  .section-header {
    margin-bottom: 20px;
    color: ${(props) => props.theme.textColor};
    font-weight: 600;
    line-height: 170% !important;
    font-size: 1.25rem;
    @media only screen and (max-width: 1023px) {
      margin-bottom: 16px;
      font-size: 1rem;
    }
  }
  /* .final-section {
    height: 10px;
    background-color: #2b2b2b;
  } */
`

export const SectionCommonProperty = styled.div`
  font-size: ${(props) => props.theme.typography.cardTitleMob};
  color: ${(props) => props.theme.fontColor};
`

export const FirstSection = styled(SectionCommonProperty)`
  padding-right: 40px;
  p {
    margin-top: 20px;
    max-width: 415px;
    font-size: ${(props) => props.theme.typography.CompanyIconText};
    color: ${(props) => props.theme.whiteAlpha60};
    line-height: 170%;
    @media only screen and (max-width: 1023px) {
      max-width: 100%;
      font-size: 0.875rem;
      margin-top: 16px;
    }
  }

  @media only screen and (max-width: 1023px) {
    padding-right: 0px;
  }

  .footer-logo {
    @media only screen and (max-width: 1023px) {
      max-width: 151px;
    }
  }
  @media only (min-width: 1024px) and (max-width: 1200px) {
    max-width: 310px;
    height: auto;
  }
`

export const SecondSection = styled(SectionCommonProperty)`
  padding: 0 40px 0 40px;
  display: flex;
  flex-direction: column;
  max-width: 502px;

  & .links-container {
    display: flex;
    flex-direction: row;
    /* gap: 50px; */
  }

  nav {
    flex-direction: row;
  }
  ul {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  li {
    list-style: none;
    list-style-type: none;
    width: 100%;
    width: 207px;

    @media only screen and (max-width: 768px) {
      width: 167px;
    }
  }
  a {
    text-decoration: none;
    color: #ffffff99;
    font-size: 16px;
    line-height: 170%;
    @media only screen and (max-width: 1023px) {
      font-size: 14px;
      line-height: 18px;
      font-weight: 400;
    }
    :hover {
      text-decoration: underline;
      color: #fff;
    }
  }

  @media only screen and (max-width: 768px) {
    padding: 0;
  }

  @media (min-width: 601px) and (max-width: 1023px) {
    padding: 0px;
  }
`

export const ThirdSection = styled(SectionCommonProperty)`
  padding: 0 0 0 40px;
  font-size: ${(props) => props.theme.typography.cardTitle};
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media only screen and (max-width: 600px) {
    flex-direction: row;
    justify-content: flex-start;
    gap: 40px;
    width: 100%;
    padding: 0;
  }

  @media (min-width: 601px) and (max-width: 1023px) {
    padding: 0 20px 0 20px;
  }

  p {
    margin-bottom: 30px;
    color: ${(props) => props.theme.base};
  }

  .fb-icon {
    margin-right: 12px;
  }

  img {
    @media only screen and (max-width: 768px) {
      width: 42px;
    }
  }
  .follow-icons {
    @media only screen and (max-width: 768px) {
      width: 147px;
    }
  }
`
export const FooterWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-self: center;
  justify-content: center;
  padding: 60px 136px;
  background: ${(props) => props.theme.footerSectionColor};

  @media only screen and (max-width: 1360px) {
    padding: 50px 60px;
  }

  @media only screen and (max-width: 600px) {
    padding: 40px 20px;
    flex-direction: column;
    align-items: start;
  }

  .divider {
    background: ${(props) => props.theme.footerBorderColor};
    width: 1px;
    height: auto;
    margin: 0px;
    @media only screen and (max-width: 600px) {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 1px;
      margin: 20px 0;
    }
  }

  @media (min-width: 601px) and (max-width: 1023px) {
    display: grid;
    gap: 20px;
    grid-template-columns: repeat(2, 1fr);

    /* First section full width */
    & > ${FirstSection} {
      grid-column: span 2;
    }

    /* Second + Third side by side */
    & > ${SecondSection} {
      grid-column: 1;
    }

    & > .second-divider {
      grid-column: 2;
      grid-row: 2;
    }

    & > ${ThirdSection} {
      grid-column: 2;
      grid-row: 2;
    }
  }

  .first-divider {
    @media (min-width: 601px) and (max-width: 1023px) {
      display: none;
    }
  }

  .social-wrapper {
    margin-top: 40px;

    @media screen and (max-width: 768px) {
      margin-top: 0px;
    }
  }

  .section-header {
    font-size: 20px;
    font-family: Montserrat, sans-serif;
    font-weight: 600;
    line-height: 170%;

    @media only screen and (max-width: 1023px) {
      font-size: 16px;
    }
  }
`

export const BottomSection = styled.div`
  width: 100%;
  background: linear-gradient(
    87.75deg,
    #0058ee 0%,
    rgba(54, 215, 183, 0.8) 100%
  );
  padding: 12px 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  .divider {
    height: 27px;
    background: #ffffff;
    width: 100%;
    width: 1px;
    margin: 0 33px;

    @media only screen and (max-width: 600px) {
      display: none;
    }
  }
  .divider-horizontal {
    display: none;

    @media only screen and (max-width: 600px) {
      display: block;
      width: 100%;
      border: 1px solid #ffffff33;
      margin: 0;
    }
  }

  .bottom-text {
    ${(props) => props.theme.paragraph2};
    font-size: 14px;
    line-height: 170%;
    color: ${(props) => props.theme.grayLight};
  }

  a {
    text-decoration: underline;
    @media only screen and (max-width: 600px) {
      display: none;
    }
  }
  @media only screen and (max-width: 600px) {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .bottom-text {
      font-size: 12px;
    }
  }
`

export const JpxSection = styled.div`
  display: flex;
  align-items: center;
  margin-top: 30px;
  gap: 30px;
  .text {
    ${(props) => props.theme.typography.descriptionMsg}
    font-family: Open Sans, sans-serif;
    color: ${(props) => props.theme.sameBase};
  }
  @media only screen and (max-width: 768px) {
    display: none;
  }
`
